import equitasLogo from './logo_equitas.png'
import './App.css'

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={equitasLogo} className="App-logo" alt="logo" />
        <p>
          The Equitas App is currently undergoing planned maintenance
        </p>
        <p>
          Thank you for your understanding
        </p>
      </header>
    </div>
  );
}

export default App;
